export const STEP_INFO = 0;
export const STEP_LIBRARY = 1;
export const STEP_SETTINGS = 2;
export const STEP_SUMMARY = 3;
export const STEP_PAYMENT = 4;
